module.exports = __webpack_public_path__ + "static/media/Lockori.ffafadba.ogg";